module.exports = __webpack_public_path__ + "static/media/end-call-icon.84c85a59.svg";